import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";

/** Assignee picker showing each technician's current open-ticket count -- the
 *  same figure psa.pick_assignee uses to choose. A dispatcher should see the
 *  load they are adding to. */
export default function AssigneeSelect({ value, onChange, includeAuto = true, testid }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/desk/workload")
      .then((r) => setRows(asArray(r.data?.technicians || r.data?.rows || r.data)))
      .catch(() => setRows([]));
  }, []);
  return (
    <select data-testid={testid || "assignee-select"} value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="bg-zinc-900 border border-zinc-800 rounded px-2 py-1 text-xs flex-1 min-w-0">
      {includeAuto && <option value="">Auto-assign (least loaded)</option>}
      {!includeAuto && <option value="">Unassigned</option>}
      {rows.map((u) => (
        <option key={u.id} value={u.id}>
          {u.name} — {u.open_tickets} open{u.past_deadline ? `, ${u.past_deadline} overdue` : ""}
        </option>
      ))}
    </select>
  );
}
